import React from 'react';

const LineChartIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg viewBox="0 0 800 600" {...props}>
      <g transform="translate(150, 100)">
        <g className="ez-grid">
          <g className="ez-grid-lines">
            <line
              transform="translate(0, 400.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 371.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 343.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 314.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 286.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 257.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 229.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 200.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 171.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 143.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 114.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 86.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 57.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 29.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(0, 0.5)"
              x2="594"
              y2="0"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
          </g>
          <g className="ez-grid-lines">
            <line
              transform="translate(0.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(66.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(132.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(198.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(264.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(330.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(396.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(462.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(528.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
            <line
              transform="translate(594.5, 0)"
              x2="0"
              y2="400"
              stroke="rgba(168,168,168,1)"
              className="ez-grid-line"
            ></line>
          </g>
        </g>
        <g className="ez-points">
          <g className="ez-line">
            <path
              d="M0,349L66,143L132,234L198,229L264,114L330,291L396,257L462,229L528,389L594,29"
              stroke="rgba(255, 0, 0, 1)"
              strokeWidth="4"
              fill="none"
              strokeLinejoin="round"
              strokeLinecap="round"
              className="ez-line"
            ></path>
          </g>
        </g>
        <g
          textAnchor="middle"
          transform="translate(0, 400)"
          className="ez-axis"
        >
          <path d="M0.5,6V-6V-0.5H594.5V6V-6" className="ez-axis-path"></path>
          <g transform="translate(0.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              1
            </text>
          </g>
          <g transform="translate(66.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              2
            </text>
          </g>
          <g transform="translate(132.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              3
            </text>
          </g>
          <g transform="translate(198.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              4
            </text>
          </g>
          <g transform="translate(264.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              5
            </text>
          </g>
          <g transform="translate(330.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              6
            </text>
          </g>
          <g transform="translate(396.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              7
            </text>
          </g>
          <g transform="translate(462.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              8
            </text>
          </g>
          <g transform="translate(528.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              9
            </text>
          </g>
          <g transform="translate(594.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text dy="0.71em" className="ez-axis-tick-text" y="9">
              10
            </text>
          </g>
        </g>
        <g textAnchor="end" transform="translate(0, 0)" className="ez-axis">
          <path d="M6,400.5H-6H-0.5V0.5H6,-6" className="ez-axis-path"></path>
          <g transform="translate(0, 400.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              0
            </text>
          </g>
          <g transform="translate(0, 371.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              5
            </text>
          </g>
          <g transform="translate(0, 343.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              10
            </text>
          </g>
          <g transform="translate(0, 314.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              15
            </text>
          </g>
          <g transform="translate(0, 286.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              20
            </text>
          </g>
          <g transform="translate(0, 257.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              25
            </text>
          </g>
          <g transform="translate(0, 229.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              30
            </text>
          </g>
          <g transform="translate(0, 200.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              35
            </text>
          </g>
          <g transform="translate(0, 171.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              40
            </text>
          </g>
          <g transform="translate(0, 143.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text dy="0.32em" className="ez-axis-tick-text" x="-9">
              45
            </text>
          </g>
          <g transform="translate(0, 114.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              50
            </text>
          </g>
          <g transform="translate(0, 86.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              55
            </text>
          </g>
          <g transform="translate(0, 57.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              60
            </text>
          </g>
          <g transform="translate(0, 29.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              65
            </text>
          </g>
          <g transform="translate(0, 0.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              70
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LineChartIcon;
